import React from "react";
import styled from "styled-components";
import HdfcLogo from "assets/hdfc-life.png";

const HeaderContainer = styled.header`
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
  z-index: 10;
`;

const Logo = styled.div`
  font-size: 18px;
  font-weight: bold;
`;

const LogoImg = styled.img`
 object-fit: "contain"
 height: 80px;
 width: 228px;
`;

interface HeaderProps {
  onHelp?: () => void;
  type?: string;
}

const Header: React.FC<HeaderProps> = ({ onHelp, type }) => {
  return (
    <HeaderContainer>
      <Logo>
        <LogoImg src={HdfcLogo} />
      </Logo>
    </HeaderContainer>
  );
};

export default Header;
